<template>
  <div>
<!--    <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'资源需求显差'}]" />-->
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
				<div class="h-thirdColumn w-newColumn">

              <el-form-item label="区域" prop="searchQuyu">
                <brselect clearable category="YLRegion" :v="q.areaCode"
                          v-model="q.areaCode"></brselect>
              </el-form-item>
                    <el-form-item label="年度">
                        <el-select filterable v-model="q.cyear"  placeholder="请选择"
                                   @change="getWeeksBySelectYear">
                            <el-option
                                    v-for="(item,index) in yearList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="月" class="h-elformWrap-2" prop="username">
                        <el-select filterable v-model="q.cmonth" placeholder="请选择"
                                   @change="getLianqunBySelectMonth"
                        >
                            <el-option
                                    v-for="(item,index) in monthList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
          </div>

            <div class="h-formBtnOut h-columnCenter">
				<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
				<el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>

            </div>
          </el-form>
        </div>
      </div>
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
          ref="multipleTable"
          :data="tableData"
          :border="true"
          stripe
          :span-method="objectSpanMethod"
          max-height="500"
          style="width: 100%"
          >
<!--            <el-table-column prop="daquName" label="大区" width="60" :show-overflow-tooltip="true"></el-table-column>-->
            <el-table-column
                    label="序号"
                    type="index"
                    min-width="10px">
            </el-table-column>
            <el-table-column prop="areaname" label="区域" min-width="60px"></el-table-column>
            <el-table-column prop="cyear" label="年度"  min-width="60px" ></el-table-column>
            <el-table-column prop="cmonth" label="月份"  min-width="60px" ></el-table-column>
            <el-table-column prop="title" label="体验群"  min-width="260px" >
            <el-table-column prop="chaingroupcount" label="月份数量"  min-width="80px"></el-table-column>
            <el-table-column prop="personalitycpcount" label="个性数量"  min-width="80px" ></el-table-column>
            <el-table-column prop="generalitycpcount" label="共性数量"  min-width="80px" ></el-table-column>
            </el-table-column>
            <el-table-column prop="titlebihuan" label="闭环"  min-width="300px" >
            <el-table-column prop="closedloopcount" label="闭环数量"  min-width="80px" ></el-table-column>
            <el-table-column prop="personalityclcount" label="个性数量"  min-width="80px" ></el-table-column>
            <el-table-column prop="generalityclcount" label="共性数量"  min-width="80px" ></el-table-column>
            </el-table-column>
            <el-table-column prop="titlexiaoliu" label="效率"  min-width="160px" >
            <el-table-column prop="efficiencyoscount" label="按期数量"  min-width="80px"></el-table-column>
            <el-table-column prop="efficiencydelaycount" label="延期数量"  min-width="80px"></el-table-column>
            </el-table-column>
            <el-table-column prop="titleweibihuan" label="未闭环"  min-width="160px" >
            <el-table-column prop="unclosedlooppercount" label="个性数量"  min-width="80px" ></el-table-column>
            <el-table-column prop="unclosedloopgencount" label="共性数量"  min-width="80px" ></el-table-column>
            </el-table-column>
            <el-table-column prop="titleweihuifu" label="未回复"  min-width="160px" >
            <el-table-column prop="noreplypercount" label="个性数量"  min-width="80px" ></el-table-column>
            <el-table-column prop="noreplygencount" label="共性数量"  min-width="80px" ></el-table-column>
            </el-table-column>
<!--          <el-table-column-->
<!--            label="操作"-->
<!--            fixed="right"-->
<!--            width="150"-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--				<div style="text-align: left;">-->
<!--					<el-button-->
<!--					   type="text"-->
<!--					   size="small"-->
<!--					   class="h-tableLink h-btn"-->
<!--					   @click="showDetail(scope.row.id)"-->
<!--					 >查看</el-button>-->
<!--                    <el-button-->
<!--                            type="text"-->
<!--                            size="small"-->
<!--                            class="h-tableLink h-btn"-->
<!--                            @click="updateDetail(scope.row.id)"-->
<!--                    >编辑</el-button>-->
<!--                    <el-button-->
<!--                            type="text"-->
<!--                            size="small"-->
<!--                            style="padding: 0;"-->
<!--                            class="h-tableLink h-btn"-->
<!--                            @click="del(scope.row.id)">-->
<!--                        删除-->
<!--                    </el-button>-->
<!--                </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
export default {
  data() {
    return {
        mclabel :'',
        dclabel:'',
        vclabel:'',
        defaultDate :this.getNow(),
      //表单
      q: {
          areaCode:'',
          deptCode:'',
          titleCode:'',
          userName:'',
          cyear:'',
          cmonth:'',
          week:'',
          searchDate:this.getNow(),
          pageSize: 10,
          pageNo: 1,
          total:0,
          cdept:'',
      },
        size:'',
        tableData: [
            {
                areaname:null,
                cyear:null,
                cmonth:null,
                chaingroupcount:null,
                personalitycpcount:null,
                generalitycpcount:null,
                closedloopcount:null,
                personalityclcount:null,
                generalityclcount:null,
                efficiencyoscount:null,
                efficiencydelaycount:null,
                unclosedlooppercount:null,
                unclosedloopgencount:null,
                noreplypercount:null,
                noreplygencount:null,

            }
        ],
      add:{
          year :new Date().getFullYear(),
          type : 2,
          month :new Date().getMonth()+2
      },
      isfb:1,
      showhistory:false,
      adminFlag:false,
      instid:null,
      pingfen:'暂无',
      paiming:'暂无',
      pjList:[],
      //表格
      multipleSelection: [],
      multipleSelectionDialog:[],
      tableData: [],
        lianqunList : [],
      //发布排行
      dialogFlag:false,
        spanArr: [],
      sumRank:[],
        yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
        qyearList:[],
        typeList:[{type:1,text:'月目标'},{type:2,text:'周目标'}],
        monthList:[1,2,3,4,5,6,7,8,9,10,11,12],
        weekList :[],
        quyuList:[],
        deptList: [],
        qweekList :[],
        newDialog: false,
        showDialog:false,
        updateDialog:false,
        showloading:false,
        updateloading:false,
      nosum:'',
      nosoc:'',
        searchDate:"",
      q2: {
          pageSize: 10,
          pageNo: 1,
          total:0,
          rqstatus:'',
      },

    };
  },
  created() {
      if(this.$store.getters.hasRole('swyl_admin')||this.$store.getters.hasRole('FANGAN')
          ||this.$store.getters.hasRole('YIMIAO_PINGTAI') ||this.$store.getters.hasRole('PINGTAI')
          ||this.$store.getters.hasRole('crm_quyu')){
        this.adminFlag = true;
      }
      this.getAllLianqun();
      this.getQuyu();
      this.getDept();
  },
    beforeRouteLeave(to, from, next) {
        from.meta.keepAlive = false;
        next();
    },
    methods: {
    getNow(){
        let date = new Date(new Date().getTime() - 24*60*60*1000);

        return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+(date.getDate());
    },
    genzongLiuch(r){
      this.instid = r.instid;
      this.showhistory = true;
    },
    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //弹框表格
    handleSelectionChangeDialog(val){
      this.multipleSelectionDialog = val;
    },

        getAllLianqun(){
            ss.createMonthGoal.getAllLianqun().then(rd => {
                this.lianqunList = rd;
            })
        },
        getDept(q){
          ss.MuBiao.getDeptList(q).then(rd => {
            this.deptList = rd;
          })
        },
        getLianqun(q){
            ss.createMonthGoal.getLianqun(q).then(rd => {
                this.lianqunList = rd;
            })
        },
        getQuyu(){
            ss.RiqPingj.selectAllQuyu().then(rd => {
                this.quyuList = rd;
            })
        },
        getWeeksBySelectYear(){
            this.getWeeks(this.add.year);
            // ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
            //     this.addlianqunList = rd;
            // })
        },
        getLianqunBySelectMonth(){
            // ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
            //     this.addlianqunList = rd;
            // })
        },
        showDetail(id){
            this.showDialog = true;
            this.showloading = true;
            ss.MuBiao.selectById({id:id}).then(rd => {
                this.add = rd.obj;
                this.showloading = false;
            });
        },
        updateDetail(id){
            this.updateDialog = true;
            this.updateloading = true;
            ss.MuBiao.selectById({id:id}).then(rd => {
                this.add = rd.obj;
                this.updateloading = false;
            });
        },
        query(){
        console.log(this.q)
          ss.DailyDemand.reportPage(this.q).then(rd => {
            this.q.total = rd.total;
            this.tableData = rd.records;
            this.getSpanArr();
            this.searchDate = this.q.searchDate;
            console.log(this.searchDate)
          });
        },
        getSpanArr() {
            this.spanArr = [];
            this.tableData.forEach((item, index) => {
                if (index === 0) {
                    this.spanArr.push(1);
                    this.position = 0;
                } else {
                    if (this.tableData[index].id && this.tableData[index].id === this.tableData[index - 1].id) {
                        this.spanArr[this.position] += 1;
                        this.spanArr.push(0);
                    } else {
                        this.spanArr.push(1);
                        this.position = index;
                    }
                }
            })

        },
        getPjList(){
            ss.DailyDemand.getPjList(this.q).then(rd => {
                this.pjList = rd.msg;
                console.log("12312312312",rd.msg);
            })
        },
        getqWeeksBySelectYear(){
            this.getqWeeks(this.q.year,1);
        },
        objectSpanMethod({row, column, rowIndex, columnIndex}) {

            // if ((column.label == '订单编号' || column.label == 'SAP订单号' || column.label == '经销商编码' || column.label == '经销商名称') && row.orderCategory == '2') {
            //     const _row = this.spanArr[rowIndex];
            //     const _col = _row > 0 ? 1 : 0;
            //     return {
            //         rowspan: _row,
            //         colspan: _col
            //     }
            // }else if ((column.label == '订单状态' || column.label == '操作') &&
            //     (row.status == '10' || row.orderCategory == '2')) {
            //     const _row = this.spanArr[rowIndex];
            //     const _col = _row > 0 ? 1 : 0;
            //     return {
            //         rowspan: _row,
            //         colspan: _col
            //     }
            // } == this.mclabel
            //if(column.label == '抢入链群'|| column.label == '创客'
/*            if(columnIndex !=7 && columnIndex !=6 && columnIndex !=8
            //  if(columnIndex ==1 && columnIndex ==2 && columnIndex ==3 && columnIndex ==4 && columnIndex ==7
                // || column.label.indexOf("月目标") != -1  || column.label == '本周目标'|| column.label == '评价'
                //  || column.label == '预实差分析'
                ){*/
                const _row = this.spanArr[rowIndex];

                const _col = _row > 0 ? 1 : 0;
                //console.log("_row:"+_row+"-_col:"+_col)
                return {
                    rowspan: _row,
                    colspan: _col
                }
/*            }*/

        },
        create(){

            this.newDialog = true;
        },
//取消按钮
        exit() {
            this.newDialog = false;
            this.showDialog = false;
            this.updateDialog = false;
        },
    handleFilter() {
      this.query();
      //this.getPjList();
    },
/*    checkRank() {
      this.$router.push("/paiming");
    },*/

    typeIndex(index){
      return index+(this.q2.pageNo-1)*this.q2.pageSize+1;
    },

    //明细导出
			exportExcel() {
                updownfile.down("/api/swyl/v1/DailyDemand/userDailyDemand/newDownloadExcel",this.q,"post",'data');
/*                ss.DailyDemand.downloadBatchExcel(this.q).then(res => { // 处理返回的文件流
                    const link = document.createElement('a')
                    let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', `资源需求显差.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }).catch(function (error) {
                    console.log("导出错误",error.toString())
                });*/
      },

    //重置
    rest() {
      var pageSize=this.q.pageSize;
      var pageNo=this.q.pageNo;
      var total=this.q.total;
      this.q=     {
            searchDate:new Date().getFullYear()+"-"+(new Date().getMonth()+1)+"-"+(new Date().getDate()-1),
                pageSize: 10,
                pageNo: 1,
                total:0,
        }
    },
  },
  mounted() {
    this.query();
    //this.getPjList();
  }
};
</script>

<style>
</style>
<style>
    .chosedialog .body_dilog{
        padding-top: 0px!important;
    }
    .chosedialog .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .chosedialog .el-dialog__body{
        padding: 0px 20px!important;
    }
    .chosedialog .h-pagination{
        padding-top:0px !important;
        padding-bottom:0px !important;
    }
	.ljjcaozuo .el-button [class*=el-icon-]+span{
		margin-left: 0;
	}
	.ljjcaozuo .h-el-icon{
		margin-right: 0;
	}
	.smTableRq .el-table tbody td .cell {
	    padding-top: 0.03rem;
	    padding-bottom: 0.03rem;
	}
	.smTableRq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.smTableRq .el-input__inner{
		background: transparent;
	}
	.ljjtablepaddingsrq .h-tableInput{
		margin-top: 0.05rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
		color: #616467;
		font-size: 0.16rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}

    .X-dai .h-formbLine .h-elformWrap-2 {
        padding-right: 0.5rem;
        width: 50% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-3 {
        padding-right: 0.5rem;
        width: 47% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-1 {
        padding-right: 0;
        width: 100% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__label{
        width: 22%;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__label{
        width: 16%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__content{
        width: 82%;
    }
    .X-dai .h-formbLine .el-form-item__label {
        width: 51%;

    }
    .X-dai .h-formbLine .el-form-item__content {
        width: 49%;
    }
    pre {
        display: block;
        font-family: inherit;
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
        padding: 0;
        margin: 0;
        line-height: inherit;
        color: inherit;
        word-break: break-all;
        background-color: transparent;
        border: none;
        border-radius: 0;
    }
</style>
